import { render } from "./InputFiatAmount.vue?vue&type=template&id=f4168b26&scoped=true"
import script from "./InputFiatAmount.vue?vue&type=script&lang=js"
export * from "./InputFiatAmount.vue?vue&type=script&lang=js"

import "./InputFiatAmount.vue?vue&type=style&index=0&id=f4168b26&scoped=true&lang=scss"
import "./InputFiatAmount.vue?vue&type=style&index=1&id=f4168b26&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4168b26"]])

export default __exports__